"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fragments = exports.fragmentName = void 0;
var fragmentName = 'authorityFields';
exports.fragmentName = fragmentName;
var fragment = "\nfragment ".concat(fragmentName, " on Authority {\n    id\n    name\n    url\n}\n");
var fragments = [fragment];
exports.fragments = fragments;